<template>
  <div>
    <md-dialog :md-active="open" class="modalEdit modal-img-archive">
      <div class="w-100 position-fixed mobile-cancel">
        <span
          class="material-icons close text-right"
          @click="closeModal"
        >close</span
        >
      </div>
      <div class="body-modal-img-archive py-5 modal-body">
        <md-dialog-title class="md-title pb-3 add-category text-left">
          <span v-if="item" class="text-uppercase">{{ item.filename }}</span>
        </md-dialog-title>

        <div class="dialog-body">
          <div v-if="item">
            <md-card class="shadow-none">
              <md-card-content class="p-0 mt-4">
                <md-card-media>
                  <div
                    v-if="item.type === 'video'"
                    class="selected__file__container__preview details-video-assets"
                  >
                    <video-player
                      ref="videoplayer"
                      :key="item.id"
                      class="videoplayer d-flex justify-content-center"
                      :options="options"
                    />
                  </div>

                  <div
                    v-if="item.type === 'image'"
                    class="selected__file__container__preview d-flex justify-content-center"
                  >
                    <img
                      :src="item.file_url"
                      alt=""
                      class="selected__file__container__preview"
                    />
                  </div>
                  <div
                    v-if="item.type === 'file'"
                    class="selected__file__container__preview"
                  >
                    <VueDocPreview
                      v-if="!['pdf','txt'].includes(this.getFileExtension( item.file_url))"
                      class="vuePreviewDoc"
                      :value="item.file_url"
                      type="office"
                    />

                    <embed
                      v-else
                      class="embed"
                      :src="item.file_url"
                      width="100%"
                      height="300"
                    />
                  </div>
                </md-card-media>
              </md-card-content>
              <md-card-content
                v-if="item.description !== 'null'"
                class="mt-4 px-0"
                style="text-align: start"
              >
                <h4 class="text-bold text-left">DESCRIPCIÓN</h4>
                {{ item.description }}
              </md-card-content>
            </md-card>
          </div>
        </div>

        <md-dialog-actions class="modal-footer">
          <md-button class="btn-primary w-auto" @click="closeModal">
            CERRAR
          </md-button>
          <md-button class="btn-primary ml-0 w-auto d-none"></md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer.vue';
import VueDocPreview from 'vue-doc-preview';

import 'video.js/dist/video-js.css';

export default {
  components: {
    VideoPlayer,
    VueDocPreview,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      default: null,
    },

  },
  emits: ['close-modal'],
  data () {
    return {
      options: {},
      currentItem: null,
      allowedExtensions: ['.mov', '.mpeg4', '.mp4', '.m4v', '.avi', '.wmv', '.mpegps', '.flv'],
    };
  },
  computed: {
    open: {
      get: function() {
        return this.isOpen;
      },
      set: function() {
        this.closeModal();
      },
    },
  },
  methods: {
    getFileExtension (url) {
      const path = new URL(url).pathname;
      const lastDotIndex = path.lastIndexOf('.');

      if (lastDotIndex === -1) {
        return '';
      }

      return path.substring(lastDotIndex + 1);
    },
    closeModal () {
      this.$emit('close-modal', 'selectedFile');
      this.val = null;
    },
  },
};
</script>
